module.exports = __webpack_public_path__ + "static/media/map-egypt-noLabel.33d29777.png";